import { TranslateService } from '@ngx-translate/core';

export class OAuthError {
  private words: any = {};
  status: number;
  subStatus: string;
  path: string;
  message: string;
  time: any;
  code: string;

  constructor(translateService: TranslateService) {
    if (!this.words.errorCode) {
      translateService.get('error.code').subscribe(s => this.words.errorCode = s);
      translateService.get('error.time').subscribe(s => this.words.errorTime = s);
      translateService.get('error.errorCodeDescription').subscribe(s => this.words.errorDescription = s);
    }
  }

  getMessage(): string {
    if (this.code) {
      // this.message = this.words.errorDescription;
      // this.code = this.code;
    } else if (!this.message) {
      this.message = this.words.errorDescription;
    }

    if (this.status === 500) {
      return `${this.message}<br><br>[${this.status}-${this.subStatus}] ${this.path},<br>` + (this.code ? `${this.words.errorCode}: ${this.code}, ` : '') + `${this.words.errorTime}: ${this.time}`;
    } else {
      return this.message;
    }
  }
}
